import AgencyHelper, { AgencyConstants } from "features/Agency/agencyHelper";
import ReconciliationReportHelper from "features/ReconciliationReport/ReconciliationReportHelper";
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from "general/components/OtherKeenComponents/KTBSButton";
import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import CustomCard from "general/components/Others/CustomCard";
import VITableRowDropDown from "general/components/VITableRowDropDown";
import AppColors from "general/constants/AppColors";
import Utils from "general/utils/Utils";
import useRouter from "hooks/useRouter";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import BreadcrumbHelper from "general/components/CustomBreadcrumb/BreadcrumbHelper";
import ToastHelper from "general/helpers/ToastHelper";
import UIHelper from "general/helpers/UIHelper";
import _ from "lodash";
import AppConstants from "general/constants/AppConstants";
import DialogEditReconciliationView from "features/ReconciliationReport/SaleReconciliationReport/components/DialogEditReconciliationView";
import AgencyReconciliationCardView from "features/ReconciliationReport/SaleReconciliationReport/components/AgencyReconciliationCardView";
import AppTabs from "general/components/AppTabs";
import { AnimatePresence, motion } from 'framer-motion';
import GroupRevenueView from "../GroupRevenueView";
import StationEnergyView from "../StationEnergyView";
import EnergyBillView from "../EnergyBillView";
import AppConfigs from "general/constants/AppConfigs";

InvestorReconciliationDetailView.propTypes = {};

function InvestorReconciliationDetailView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { t } = useTranslation();
    const { reconciliationId } = router.query;
    const agencyId = router?.query?.agencyId;
    const [reconciliationDetail, setReconciliationDetail] = useState(null);
    const [agencyDetail, setAgencyDetail] = useState(null);
    const [groupInvestmentList, setGroupInvestmentList] = useState(null);
    const { user } = useSelector((state) => state.auth);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const isOrganizationAgency = useMemo(() => {
        return reconciliationDetail?.agency?.type === 'ORGANIZATION';
    }, [reconciliationDetail]);

    useEffect(() => {
        handleGetInvestorReconciliationDetail();
    }, [reconciliationId, agencyId]);

    const [selectedTab, setSelectedTab] = useState('Doanh thu hợp tác kinh doanh');
    const TAB_HASH_MAP = {
        'Doanh thu hợp tác kinh doanh': 'group-revenue',
        'Tiền điện trạm sạc': 'station-energy',
        'Hóa đơn tiền điện': 'energy-bill',
    };
    const tabs = useMemo(() => {
        return [
            {
                name: 'Doanh thu hợp tác kinh doanh'
            },
            {
                name: 'Tiền điện trạm sạc',
                description: {
                    textHeader: 'Tiền điện trạm sạc',
                    text: 'Dữ liệu được cập nhật tự động từ hệ thống quản lý trạm.',
                }
            },
            // {
            //     name: 'Hóa đơn tiền điện',
            //     description: {
            //         textHeader: 'Hóa đơn tiền điện',
            //         text: 'Dữ liệu được cập nhật thủ công bởi nhà đầu tư, chủ mặt bằng hoặc nhà điều hành.',
            //     }
            // },
        ].reverse();
    }, []);

    const hash = router?.location?.hash;

    useEffect(() => {
        const { child } = Utils.parseHash(hash) || {};
        const tabName = Object.keys(TAB_HASH_MAP).find(
            key => TAB_HASH_MAP[key] === child
        );
        if (tabName) {
            setSelectedTab(tabName);
        }
    }, [hash]);

    const groupRevenueView = useMemo(() => {
        return (
            <GroupRevenueView
                agencyId={agencyId}
                reconciliationDetail={reconciliationDetail}
            />
        );
    }, [agencyDetail, reconciliationDetail]);

    const stationEnergyView = useMemo(() => {
        const formatData = (reconciliationDetail?.metadata?.stations || [])
            .filter(item => item?.station?.isAgencyPayEnergyCost === 1);

        return (
            <StationEnergyView
                agencyId={agencyId}
                primaryRole='INVESTOR'
                stationEnergyList={reconciliationDetail?.metadata?.stations}
                stationEnergyTotal={reconciliationDetail?.metadata?.stations?.length}
                filter={{
                    page: 0,
                    limit: AppConfigs.defaultPageLimit,
                }}
                reconciliationDetail={reconciliationDetail}
            />
        );
    }, [agencyId, reconciliationDetail]);

    const energyBillView = useMemo(() => {
        const formatData = (reconciliationDetail?.metadata?.stations || [])
            .filter(item => item?.station?.energyBills?.length > 0);

        return (
            <EnergyBillView
                agencyId={agencyId}
                primaryRole='INVESTOR'
                energyBillList={formatData}
                energyBillTotal={formatData?.length}
                filter={{
                    page: 0,
                    limit: AppConfigs.defaultPageLimit,
                }}
                reconciliationDetail={reconciliationDetail}
            />
        );
    }, [agencyDetail, reconciliationDetail]);

    // MARK: ---- METHOD ----

    const handleGetInvestorReconciliationDetail = () => {
        if (reconciliationId) {
            AgencyHelper.API.requestGetReconciliationDetail(reconciliationId).then(
                (reconciliationDetail) => {
                    setReconciliationDetail(reconciliationDetail);
                    setAgencyDetail(reconciliationDetail?.agency);
                    setGroupInvestmentList(reconciliationDetail?.metadata?.groupShare?.investments);
                }
            );
        } else if (agencyId) {
            const paramGetReconciliationList = {
                agencyId,
            };
            AgencyHelper.API.requestGetReconciliationList(paramGetReconciliationList).then(
                (reconciliationList) => {
                    setReconciliationDetail(_.maxBy(reconciliationList, 'reconciliationId'));
                }
            );
        }
    }

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;

        const { parent } = Utils.parseHash(hash) || {};
        const childValue = TAB_HASH_MAP[newTab];

        if (!childValue) return;

        const newHash = `#parent=${parent || 'investor-reconciliation'}&child=${childValue}`;
        router.navigate(newHash);
        setSelectedTab(newTab);
    };

    const SaleReconciliationInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex align-items-center w-100 p-0">
                    <div className="d-flex flex-column w-100">
                        <div className="d-flex align-items-center gap-2" style={{ overflow: 'hidden' }}>
                            <div
                                className="font-weight-bolder"
                                style={{
                                    color: AppColors.gray[800],
                                    fontSize: Utils.returnFontSize(18),
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {agencyDetail?.name}{" "}
                                • {agencyDetail?.agencyCode ?? agencyDetail?.agencyId}
                            </div>

                            <span className="min-w-100px ml-3">
                                <KTLabel
                                    text={ReconciliationReportHelper.getReconciliationStatusName(reconciliationDetail?.status)}
                                    isInline={true}
                                    size={KTLabelSize.medium}
                                    additionalClassName={`label-light-${ReconciliationReportHelper.getReconciliationStatusColor(
                                        reconciliationDetail?.status
                                    )}`}
                                />
                            </span>
                        </div>
                        <div style={{ fontSize: Utils.returnFontSize(14), color: AppColors.gray[700] }}>
                            Đối soát doanh thu NĐT nhượng quyền tháng {Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/yyyy')}
                        </div>
                    </div>

                    <div className="d-flex gap-3">
                        {!adminRole && reconciliationDetail?.status === 'ADMIN_SIGNED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAgencySignReconciliation(reconciliationDetail, handleGetInvestorReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        {adminRole && reconciliationDetail?.status === 'CREATED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Duyệt & ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAdminSignReconciliation(reconciliationDetail, handleGetInvestorReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                                    text: t('edit'),
                                    click: () => {
                                        AppCustomDialogHelper.show(
                                            `Sửa đối soát tháng ${Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/YYYY')}`,
                                            <DialogEditReconciliationView
                                                item={reconciliationDetail}
                                                onCancel={() => {
                                                    AppCustomDialogHelper.hide();
                                                }}
                                                onDone={() => {
                                                    ToastHelper.showSuccess('Cập nhật đối soát thành công!')
                                                    AppCustomDialogHelper.hide();
                                                    handleGetInvestorReconciliationDetail();
                                                }}
                                            />,
                                            'md',
                                            true,
                                            true
                                        )
                                    },
                                    show: adminRole && (reconciliationDetail?.reconciliationType === 'PAPER' && reconciliationDetail?.status === 'COMPLETED'),
                                },
                                // {
                                //     iconElement: <i className="fa-regular fa-memo-circle-info"></i>,
                                //     text: 'Đơn hàng liên quan',
                                //     click: () => {
                                //         if (!adminRole) {
                                //             router.navigate(`/order?month=${reconciliationDetail?.month}`);
                                //         } else {
                                //             router.navigate(`/order?agencyId=${reconciliationDetail?.agency?.agencyId}&month=${reconciliationDetail?.month}`);
                                //         }
                                //     },
                                //     show: true,
                                // },
                                {
                                    iconElement: <i className="fa-regular fa-file-chart-column"></i>,
                                    text: t('Xem file đối soát'),
                                    click: () => {
                                        if (Utils.isValid(reconciliationDetail?.document)) {
                                            Utils.openInNewTab(Utils.getFullUrl(reconciliationDetail?.document));
                                        }
                                    },
                                    show: !!reconciliationDetail?.document,

                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-arrow-rotate-left"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo lại đối soát',
                                    click: () => {
                                        AgencyHelper.UI.showDialogCreateReconciliation('INVESTOR', reconciliationDetail, handleGetInvestorReconciliationDetail)
                                    },
                                    show: adminRole
                                        && [
                                            AgencyConstants.AgencyReconciliationStatus.CREATED,
                                            AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED,
                                        ].includes(reconciliationDetail?.status),
                                },
                                {
                                    iconElement: <i className="far fa-download"></i>,
                                    text: t('Tải đối soát excel'),
                                    click: () => Utils.openInCurrentTab(reconciliationDetail?.documentXLSX),
                                    show: !!reconciliationDetail?.documentXLSX,

                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Gửi phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetInvestorReconciliationDetail),
                                    show: !adminRole && reconciliationDetail?.status !== 'AGENCY_SIGNED',
                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Xem phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetInvestorReconciliationDetail),
                                    show: adminRole && !!reconciliationDetail?.feedback,
                                },
                                {
                                    iconElement: <i className="far fa-file-check"></i>,
                                    text: 'Duyệt hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogApprovalInvoice(reconciliationDetail, adminRole, handleGetInvestorReconciliationDetail),
                                    show: adminRole && reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED' && !!reconciliationDetail?.attachedFiles?.length,
                                },
                                {
                                    iconElement: <i className="far fa-upload"></i>,
                                    text: 'Tải lên hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogUploadInvoiceDocument(reconciliationDetail, handleGetInvestorReconciliationDetail),
                                    show: reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED',
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const groupCommissionList = useMemo(() => {
        return [
            {
                name: 'Tổng doanh thu trạm sạc theo phương tiện',
                value: Math.floor(reconciliationDetail?.totalRevenue),
                unit: 'VNĐ',
                color: '#30BD6F',
                icon: 'fa-solid fa-badge-dollar',
                show: true,
            },
            {
                name: `Thuế TNCN (${reconciliationDetail?.taxRate * 100}%)`,
                value: Math.floor(reconciliationDetail?.taxAmount),
                unit: 'VNĐ',
                color: '#FE6358',
                icon: 'fa-solid fa-badge-percent',
                show: !isOrganizationAgency,
            },
            {
                name: 'Doanh thu NĐT được nhận',
                value: Math.floor(reconciliationDetail?.totalRevenue - reconciliationDetail?.taxAmount),
                unit: 'VNĐ',
                color: '#FFAA24',
                icon: 'fa-solid fa-badge-dollar',
                show: true,
            }
        ];
    }, [reconciliationDetail, adminRole, isOrganizationAgency]);

    const GroupCommissionReconciliationInfo = () => {
        return (
            <div
                className="overflow-hidden position-relative mt-4"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '10px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    {/* barchart */}
                    <div className="w-100 d-flex flex-column gap-1 p-4"
                        style={{
                            borderBottom: `1px solid ${AppColors.gray[300]}`
                        }}
                    >
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            Doanh thu NĐT được nhận
                        </div>
                    </div>
                    {/* body */}
                    <div className="w-100 d-flex p-4 gap-3">
                        {groupCommissionList?.filter(cardInfo => cardInfo?.show)
                            ?.map((cardInfo, index) => (
                                <div
                                    key={index}
                                    className="flex-grow-1 p-0"
                                >
                                    <AgencyReconciliationCardView
                                        name={cardInfo.name}
                                        value={cardInfo.value}
                                        unit={cardInfo.unit}
                                        color={cardInfo.color}
                                        icon={cardInfo.icon}
                                        descriptionValue={cardInfo.descriptionValue}
                                        additionalDes={cardInfo?.additionalDes}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div >
        )
    }

    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: 'Báo cáo đối soát NĐT NQ',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết báo cáo đối soát' },
                ])}
            </div>

            <div className="m-4 mt-16">
                {/* thong tin Dai ly */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-flex flex-column">
                            <div
                                className={`col-12 p-0 h-100`}
                            >
                                <SaleReconciliationInfo />

                                <GroupCommissionReconciliationInfo />

                            </div>

                        </div>
                    }
                />

                {/* table */}
                <div className="pt-0">
                    <AppTabs
                        tabs={tabs}
                        activeTab={selectedTab}
                        handleClick={handleSelectedTab}
                        hasTabInfo={true}
                        className="mt-2 mr-3"
                        additionalClassName=""
                    />
                    <div
                        className="bg-white shadow"
                        style={{
                            borderLeft: `1px solid ${AppColors.gray[300]}`,
                            borderRight: `1px solid ${AppColors.gray[300]}`,
                            borderBottom: `1px solid ${AppColors.gray[300]}`,
                            borderRadius: '0px 10px 10px 10px',
                        }}
                    >
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={selectedTab}
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                exit={{ y: -10, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                            >
                                {selectedTab == 'Doanh thu hợp tác kinh doanh' && (
                                    <div className="px-5 pb-3 pt-4">{groupRevenueView}</div>
                                )}
                                {selectedTab == 'Tiền điện trạm sạc' && (
                                    <div className="px-5 pb-3 pt-4">{stationEnergyView}</div>
                                )}
                                {selectedTab == 'Hóa đơn tiền điện' && (
                                    <div className="px-5 pb-3 pt-4">{energyBillView}</div>
                                )}
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvestorReconciliationDetailView;
